// removed by extract-text-webpack-plugin
module.exports = {"ageLabel":"AgeLabel-ageLabel","ageFresh":"AgeLabel-ageFresh","ageOk":"AgeLabel-ageOk","ageOld":"AgeLabel-ageOld","ageLabelRemoved":"AgeLabel-ageLabelRemoved","ageRowViewed":"AgeLabel-ageRowViewed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AgeLabel/index.css
// module id = 1695
// module chunks = 0